import { ISelectable } from 'src/app/tools/selectable';
import { ConditionPrelevement } from '../description/condition-prelevement';
import { FaciesEcoulement } from '../description/facies-ecoulement';
import { MorphologieLit } from '../description/morphologie-lit';
import { NatureBerge } from '../description/nature-berge';
import { PhysiqueChimieInSitu } from '../description/physique-chimie-insitu';
import { QualiteVisuelleEau } from '../description/qualite-visuelle-eau';
import { Document } from '../Shared/document';
import { ELIMSData } from '../Shared/elims-data';
import { Tracabilite } from '../Tracabilite/tracabilite';
import { EInterventionStatus } from './enum/intervention-status';
import { EInterventionType } from './enum/intervention-type';
import { SamplingPoint } from './sampling-point';
import { User } from './user';

export class Intervention extends ISelectable {

    id: number; // For IndexedDB

    Code: string;
    SampleCode: string;
    SamplingDuration: number;
    Date: Date;
    Type: EInterventionType;
    CreatedOn: Date;
    CreatedBy: string;
    CreatedByFullName: string;

    /**
     * Environment description
     */
    ConditionPrelevement: ConditionPrelevement = new ConditionPrelevement();
    NatureBerge: NatureBerge = new NatureBerge();
    MorphologieLit: MorphologieLit = new MorphologieLit();
    QualiteVisuelleEau: QualiteVisuelleEau = new QualiteVisuelleEau();
    FaciesEcoulement: FaciesEcoulement = new FaciesEcoulement();
    PhysiqueChimieInSitu: PhysiqueChimieInSitu = new PhysiqueChimieInSitu();
    ProcessCode: string;
    /**
     *  !Environment description
     */

    GroupementPrelevement: boolean;

    Status: EInterventionStatus;
    GeographicAccess: string;
    Tracabilite: Tracabilite = new Tracabilite();

    PartnerCode: string;
    SamplingPoint: SamplingPoint = new SamplingPoint();
    Sampler: User = new User();
    Responsible: User = new User();
    Sampler3: User = new User();
    Documents: Document[] = [];
    ELIMSData: ELIMSData = new ELIMSData();
    COFRAC: boolean;

    PreviousSampleCodes: string[] = [];
    NextSampleCodes: string[] = [];

    static mapFromJSON(json): Intervention {
        const i = new Intervention();

        i.Code = json.code;
        i.ProcessCode = json.processCode;
        i.SampleCode = json.sampleCode;
        i.SamplingDuration = json.samplingDuration;
        i.Date = new Date(json.date);
        i.Type = json.type;
        i.CreatedBy = json.createdBy;
        i.CreatedByFullName = json.createdByFullname;
        i.CreatedOn = json.createdOn;
        i.GeographicAccess = json.geographicAccess;
        i.Status = json.status;
        i.PartnerCode = json.partnerCode;
        i.GroupementPrelevement = json.groupementPrelevement;
        i.COFRAC = json.cofrac;

        if (json.sampler) {
            i.Sampler = User.mapFromJSON(json.sampler);
        }
        if (json.responsible) {
            i.Responsible = User.mapFromJSON(json.responsible);
        }
        if (json.sampler3) {
            i.Sampler3 = User.mapFromJSON(json.sampler3);
        }
        if (json.samplingPoint) {
            i.SamplingPoint = SamplingPoint.mapFromJSON(json.samplingPoint);
        }

        if (json.conditionPrelevement) {
            i.ConditionPrelevement = ConditionPrelevement.mapFromJSON(json.conditionPrelevement);
        }
        if (json.natureBerge) {
            i.NatureBerge = NatureBerge.mapFromJSON(json.natureBerge);
        }
        if (json.morphologieLit) {
            i.MorphologieLit = MorphologieLit.mapFromJSON(json.morphologieLit);
        }
        if (json.qualiteVisuelleEau) {
            i.QualiteVisuelleEau = QualiteVisuelleEau.mapFromJSON(json.qualiteVisuelleEau);
        }
        if (json.faciesEcoulement) {
            i.FaciesEcoulement = FaciesEcoulement.mapFromJSON(json.faciesEcoulement);
        }
        if (json.physiqueChimieInSitu) {
            i.PhysiqueChimieInSitu = PhysiqueChimieInSitu.mapFromJSON(json.physiqueChimieInSitu);
        }

        if (json.tracabilite) {
            i.Tracabilite = Tracabilite.mapFromJSON(json.tracabilite);
        }

        if (json.elimsData) {
            i.ELIMSData = ELIMSData.mapFromJSON(json.elimsData);
        }

        if (json.documents) {
            i.Documents = json.documents.map(jsonItem => Document.mapFromJSON(jsonItem));
        }

        if (json.previousSampleCodes) {
            i.PreviousSampleCodes = json.previousSampleCodes.map(jsonItem => jsonItem);
        }
        if (json.nextSampleCodes) {
            i.NextSampleCodes = json.nextSampleCodes.map(jsonItem => jsonItem);
        }
        return i;
    }
}
